import { render, staticRenderFns } from "./OrderMy.vue?vue&type=template&id=b062cc94&scoped=true&"
import script from "./OrderMy.vue?vue&type=script&lang=js&"
export * from "./OrderMy.vue?vue&type=script&lang=js&"
import style0 from "./OrderMy.vue?vue&type=style&index=0&id=b062cc94&lang=less&scoped=scoped&"
import style1 from "./OrderMy.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b062cc94",
  null
  
)

export default component.exports